const formatEuros = (num) => `€ ${num.toLocaleString('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;

export default formatEuros;
